import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import { API_URL, customStyles, secret_key, storedData } from './Constants';
import loadingGif from "../assets/loading.gif"
//import '../Dashboard.css'; // reuse your existing styles

const Notifications = () => {
  const navigate = useNavigate();

  // --- Decrypt Token & User Data ---
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';
  if (encryptedToken) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Token decryption error:', error);
    }
  }
  const token = `Bearer ${decryptedToken}`;

  let loggedUserData = null;
  if (storedData) {
    const bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    loggedUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  // --- State ---
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // --- Fetch Notifications Linked to Parent ---
  const fetchNotifications = async () => {
    if (!loggedUserData) return;
    setLoading(true);
    try {
      const res = await axios.get(
        `${API_URL}/notifications/${loggedUserData.company_id}/${loggedUserData.parent_no}`,
          {
                headers: {
                  Authorization: `CustomToken ${secret_key}`,
                },
              }
      );
       
      if (res.data.success) {
        setNotifications(res.data.details || []);
      } else {
        Swal.fire("Info", res.data.message || "No linked Notifications found", "info");
      }
    } catch (err) {
  console.error("Fetch Notifications error:", err);

  const backendMessage =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    JSON.stringify(err?.response?.data);

  const status = err?.response?.status || "No status";
  const serverError = backendMessage || "Unknown server error";

  Swal.fire({
    title: "API Error",
    html: `
      <p><b>Status:</b> ${status}</p>
      <p><b>Message:</b> ${serverError}</p>
      <p><b>Token Sent:</b> ${token}</p>
    `,
    icon: "error",
    width: "600px",
  });

  if (status === 401) navigate(0);

} finally {
  setLoading(false);
}

  };

  useEffect(() => {
    fetchNotifications();
  }, []);
  // --- Format Currency ---
  const formatCurrency = (val) =>
    new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
    }).format(val || 0);


  // --- Render ---
  return (
   <div className="dashboard-container container-fluid position-relative">

  {/* Loading Overlay */}
  {loading && (
    <div className="loading-overlay d-flex align-items-center justify-content-center">
      <img className="loading-img" src={loadingGif} alt="Loading..." />
    </div>
  )}

  {/* Header */}
  <header className="dashboard-header py-3 border-bottom mb-4">
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
      <h1 className="mb-0 fw-bold">My Notifications</h1>

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Notifications</li>
        </ol>
      </nav>
    </div>
  </header>

  <div className="row">

    {/* ================= Notifications ================= */}
    <div className="col-12 col-lg-8 mb-4">

      <div className="card shadow-sm rounded-4 border-0">

        <div className="card-header bg-gradient-primary text-white rounded-top-4">
          <h5 className="mb-0">
            <i className="fas fa-bell me-2"></i>
            Linked Notifications
          </h5>
        </div>

        {/* ---------- DESKTOP TABLE ---------- */}
        <div className="card-body p-0 d-none d-md-block">
          <div className="table-responsive">
            <table className="table table-striped align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Title</th>
                  <th>Message</th>
                </tr>
              </thead>

              <tbody>
                {notifications?.length ? (
                  notifications.map((n, i) => (
                    <tr key={i}>
                      <td className="fw-semibold">{n.title}</td>
                      <td style={{ whiteSpace: "normal" }}>
                        {n.sms}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center text-muted py-4">
                      <i className="fas fa-bell-slash fa-lg d-block mb-2"></i>
                      No notifications found
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>

        {/* ---------- MOBILE CARDS ---------- */}
        <div className="card-body d-block d-md-none">

          {notifications?.length ? (
            notifications.map((n, i) => (
              <div key={i} className="card shadow-sm border-0 mb-3">

                <div className="card-body">

                  <div className="fw-semibold mb-2 text-primary">
                    <i className="fas fa-bell me-2"></i>
                    {n.title}
                  </div>

                  <p className="mb-0 small text-muted">
                    {n.sms}
                  </p>

                </div>

              </div>
            ))
          ) : (
            <div className="text-center text-muted py-4">
              <i className="fas fa-bell-slash fa-lg d-block mb-2"></i>
              No notifications found
            </div>
          )}

        </div>

      </div>
    </div>

    {/* ================= SIDEBAR ================= */}
    <div className="col-12 col-lg-4 mb-4">

      <div
        className="card shadow-lg sticky-top border-0 rounded-4"
        style={{ top: "80px" }}
      >
        <div className="card-header bg-gradient-secondary text-white rounded-top-4">
          <h4 className="mb-0">
            <i className="fas fa-info-circle me-2"></i>
            Notes
          </h4>
        </div>

        <div className="card-body">
          <p className="text-muted small mb-0">
            Here you can view all notifications linked to your account.
          </p>
        </div>
      </div>

    </div>

  </div>
</div>
  );
};

export default Notifications;
